/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/prop-types */
import { useState } from 'react';
import { Row, Col, Typography, Button, message, Tooltip } from 'antd';
import { DownloadOutlined, FilePdfOutlined, SaveOutlined } from '@ant-design/icons';
import CsvDownloader from 'react-csv-downloader';

import axios from 'axios';

import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';
import { useNavigate } from 'react-router-dom';
import { datetimeCovertertolocal } from '../../datetime-converter';


export function BatchDownloader(props) {
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const envstrgebatch = process.env.REACT_APP_BATCH_SIZE == undefined || process.env.REACT_APP_BATCH_SIZE == 'undefined' ? 1000 : process.env.REACT_APP_BATCH_SIZE;
	const BATCH_SIZE = localStorage.getItem(`${dashboardtype.toUpperCase()}_BATCH_SIZE`) == 'null' ?  parseInt(envstrgebatch) : parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_BATCH_SIZE`));
	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;

	const TOTAL = props.total;
	const BATCHES = TOTAL / BATCH_SIZE;
	const batches = [];
    
	let startIndex = 1;
	let index = 0;
    
	for (let i=0; i< BATCHES; i++) {
		let start = startIndex;
		let end = (startIndex + BATCH_SIZE-1);
      
		end = (end >= TOTAL) ? TOTAL : end;
      
		let batch = { index: index, start: start, end: end, fetched: false };
  
		batches.push(batch);
      
		startIndex += BATCH_SIZE;
		index++;
	}
  
	return <>
		<Row gutter={16} style={{
			padding: '5px',
			marginTop: '10px',
			maxHeight: '250px',
			overflowY: 'scroll'
		}}>
			<Col span={24}>
				<Row style={{
					backgroundColor: '#d3d3d3',
					alignItems: 'center',
					marginTop: '5px',
					marginBottom: '5px',
					padding: '8px'
				}}>
					{batches.map((batch, index) =>
						<>
							<Col span={18} style={{ marginBottom: '6px' }}>
								<Typography>{langdata && langdata.Batch ? langdata.Batch:'Batch'} {index+1} : {langdata && langdata.Rows ? langdata.Rows:'Rows'} {batch.start} {langdata && langdata.to ? langdata.to:'to'} {batch.end}</Typography>
							</Col>
							<Col span={6} style={{ marginBottom: '6px', display : 'flex', justifyContent : 'flex-end' }}>
								<BatchDownloaderItem index={index} batch={batch} url={props.url} title={langdata && langdata.DownloadReport ? langdata.DownloadReport:'Download Report'}/>
							</Col>
						</>
					)}
				</Row>
			</Col>
		</Row>
	</>;
}
  
export function BatchDownloaderItem(props) {

	const url = props.url ? props.url : null;
	const [loading, setLoading] = useState(false);
	const [fetched, setFetched] = useState(false);
	const [data, setData] = useState({});
	const navigate = useNavigate();
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
  
	const envExtendTimeout = process.env.REACT_APP_EXTEND_TIMEOUT == undefined || process.env.REACT_APP_EXTEND_TIMEOUT == 'undefined' ? 180000 : process.env.REACT_APP_EXTEND_TIMEOUT;
	const extendTimeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_EXTEND_TIMEOUT`) == 'null' ? parseInt(envExtendTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_EXTEND_TIMEOUT`));

	const envstrgebatch = process.env.REACT_APP_BATCH_SIZE == undefined || process.env.REACT_APP_BATCH_SIZE == 'undefined' ? 1000 : process.env.REACT_APP_BATCH_SIZE;
	const BATCH_SIZE = localStorage.getItem(`${dashboardtype.toUpperCase()}_BATCH_SIZE`) == 'null' ?  parseInt(envstrgebatch) : parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_BATCH_SIZE`));
	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;

	const columns = [
		{
			id: 'id',
			displayName: `${langdata && langdata.Id ? langdata.Id:'Id'}`
		}, 
		{
			id: 'name',
			displayName: `${langdata && langdata.Name ? langdata.Name:'Name'}`
		},
		{
			id: 'user',
			displayName: `${langdata && langdata.UserName ? langdata.UserName:'User Name'}`
		},
		{
			id: 'dateTime',
			displayName: `${langdata && langdata.DateTime ? langdata.DateTime:'Date Time'}`
		},
		{
			id: 'pipelineChainage',
			displayName: `${langdata && langdata.PipelineChainage ? langdata.PipelineChainage:'Pipeline Chainage'}`
		},
		{
			id: 'remarks',
			displayName: `${langdata && langdata.Remarks ? langdata.Remarks:'Remarks'}`
		},
      
	];
  
	const fetchData = (index) => {
		setLoading(true);
  
		let skip =  (index>=1) ? (BATCH_SIZE * index) : (0);
  
		const config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: url.base + `?$limit=${BATCH_SIZE}&$skip=${skip}&` + url.params,
			timeout: extendTimeout,
			headers: {
				'Content-Type': 'application/json', 
				'Authorization': `Bearer ${authtoken}`
			}
		};
      
		axios.request(config) .then((response) => {
			if (response && response.data) {
				let datas = [];

				if (response.data && response.data.data) {
					response.data.data.map( (item) => {
						const dateTime = datetimeCovertertolocal(item.dateTime?item.dateTime : '<Not Set>');
						const newDatetime = item.dateTime ? (dateTime.localdate + ' ' + dateTime.localtime) : '<Not Set>';
						let data = {};
              
						data.id = item.id ? item?.id : null ;
						data.name = item.name ? item?.name : 'No Data';
						data.user = item?.users  ? `${item.users.firstName} ${item.users.lastName}` : 'No Data';
						data.dateTime = newDatetime ? newDatetime : 'No Data';
						data.remarks = item.remarks ? item.remarks : 'No Data';
						data.pipelineChainage =item?.pipelineChainage !== undefined && item?.pipelineChainage !== null? item.pipelineChainage: 'No Data';
						
						

						return datas.push(data);
					});
  
					setFetched(true);
					setData(datas);
					setLoading(false);
				} else {
					setFetched(true);
					setData([]);
					setLoading(false);   
				}
			} else {
				setFetched(false);
				setData([]);
				setLoading(false);
			}
		}).catch((error) => {
			console.log(error);
        
			setFetched(false);
			setData([]);
			setLoading(false);
			if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
				message.config({
					duration : 5,
					maxCount : 1,
				});
				message.open({
					type: 'error',
					content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
				});
			}
		});
	};
	
	const handleSTSPDFDownload = (data) => {		
	// DownloadPDF(jsonData, batchNo);
		navigate(( '/incident-report-generation'),{ state: { data: data } });
		
	};

	return <>
		{ props && props.batch && fetched === false ? (
			<Tooltip title={langdata && langdata.FetchdatafromOneView ? langdata.FetchdatafromOneView:'Fetch data from OneView'}>
				<Button type="primary" shape="circle" loading = {loading} icon={<DownloadOutlined />} onClick={() => fetchData(props.index)}></Button>
			</Tooltip>
		) : (
			<>
				<Row>
					<Col span={24} style={{ display : 'flex'}}>
						<CsvDownloader datas={data} filename={`${langdata && langdata.IncidentReport ? langdata.IncidentReport :'Incident-report'}-${props.index}`} extension=".csv" columns={columns}> 
							<Tooltip title={langdata && langdata.Downloadtomycomputer ? langdata.Downloadtomycomputer:'Download to my computer'}>
								<Button type="primary" shape="circle" icon={<SaveOutlined />} style={{ backgroundColor: '#008000', border: '1px solid #008000' }}></Button>
							</Tooltip>
						</CsvDownloader>
					&nbsp;&nbsp;	
						<Tooltip title={langdata && langdata.DownloadSTSPDFtomycomputer ? langdata.DownloadSTSPDFtomycomputer:'Download STS PDF to my computer'}>
							<Button type="primary" shape="circle" onClick={()=>{handleSTSPDFDownload(data);}} icon={<FilePdfOutlined />} style={{ backgroundColor: '#e69b19', 								 border: '1px solid #e69b19' }}></Button>
						</Tooltip>

					</Col>
				</Row>
			</>
		)}
      
	</>;
}